import type { SVGProps } from "react";
export interface ClipboardListIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ClipboardListIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ClipboardListIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 19V6A4.125 4.125 0 0 1 7 1.875h1.25l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H7c-1.036 0-1.875.84-1.875 1.875v13c0 1.036.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875V6c0-1.035-.84-1.875-1.875-1.875h-1.25a1.125 1.125 0 0 1 0-2.25H17A4.125 4.125 0 0 1 21.125 6v13A4.126 4.126 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19"
      />
      <path
        fill={color}
        d="M15.997 16.87a1.125 1.125 0 0 1 .006 2.25l-4 .01-.115-.006a1.125 1.125 0 0 1 .109-2.244zm0-4a1.125 1.125 0 0 1 .006 2.25l-4 .01-.115-.005a1.126 1.126 0 0 1 .109-2.246l4-.008Zm0-4a1.125 1.125 0 0 1 .006 2.25l-4 .01-.115-.006a1.126 1.126 0 0 1 .109-2.244zM9.375 18a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 8 16.625l.141.007A1.376 1.376 0 0 1 9.375 18m0-4a1.375 1.375 0 0 1-2.743.14L6.625 14l.007-.14A1.376 1.376 0 0 1 8 12.623l.141.008c.693.07 1.234.656 1.234 1.368Zm0-4a1.375 1.375 0 0 1-2.743.14L6.625 10l.007-.141A1.375 1.375 0 0 1 8 8.625l.141.008c.693.07 1.233.655 1.234 1.367m5.5-6a.875.875 0 0 0-.874-.875H10A.875.875 0 0 0 9.125 4v.375h5.75zm2.25 1c0 .897-.727 1.624-1.624 1.625H8.5A1.624 1.624 0 0 1 6.875 5V4A3.125 3.125 0 0 1 10 .875h4A3.125 3.125 0 0 1 17.126 4v1Z"
      />
    </svg>
  );
}
